import * as yup from 'yup';

const creativeSchema = yup.object().shape({
  id: yup.string().required(),
  creative_id: yup.string().required(),
  creative_type: yup.string().oneOf(['video', 'image']).required(),
  name: yup.string().required(),
});

const adGroupSchema = yup.object().shape({
  account_id: yup.string().required(),
  campaign_id: yup.string().required(),
  campaign_name: yup.string().required(),
  ad_group_id: yup.string().required(),
  ad_group_name: yup.string().required(),
  flow: yup.string().required('Ad group has no flow'),
});

export const createPinterestAdSchema = yup.object().shape({
  app: yup.string().required('App is required').trim().min(1),
  creatives: yup
    .array()
    .of(creativeSchema)
    .required('Creatives are required')
    .min(1, 'At least one creative must be selected'),
  ad_groups: yup
    .array()
    .of(adGroupSchema)
    .required('Ad groups are required')
    .min(1, 'At least one ad group must be selected'),
});

export type ValidatedCreatePinterestAdParams = yup.InferType<typeof createPinterestAdSchema>;
